// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GOR08","top":"styles_top__2GpkO"};